import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

class InstagramBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();

    // Set the required attributes for Instagram embed
    node.setAttribute('class', 'instagram-media');
    node.setAttribute('data-instgrm-version', '14');

    // If value is a URL, create a proper Instagram embed
    if (typeof value === 'string') {
      if (value.includes('instagram.com')) {
        node.setAttribute('data-instgrm-permalink', value);
        node.innerHTML = `<a href="${value}" target="_blank">View this post on Instagram</a>`;
      } else {
        // Clean the HTML content and remove any trailing characters
        const cleanValue = value
          .replace(/^["']|["']$/g, '')
          .replace(/>\s*$/, '>');
        node.innerHTML = cleanValue;
      }
    }

    return node;
  }

  static value(node) {
    return node.getAttribute('data-instgrm-permalink') || node.innerHTML;
  }

  static formats(domNode) {
    return {
      'data-instgrm-permalink': domNode.getAttribute('data-instgrm-permalink'),
      class: domNode.getAttribute('class'),
    };
  }
}

InstagramBlot.blotName = 'instagram';
InstagramBlot.tagName = 'blockquote';

Quill.register(InstagramBlot);
